import app from './init'

import accordion from './components/accordion.js'
import account from './components/account.js'
import brands from './components/brands.js'
import cart from './components/cart.js'
import cancellationPortal from './components/cancellation-portal.js'
import collection from './components/collection.js'
import collectionSubcategories from './components/collection-subcategories.js'
import collectionTopline from './components/collection-topline.js'
import footerComponent from './components/footer-component.js'
import headerComponent from './components/header-component.js'
import flowPage from './components/flow-page.js'
import giftCards from "./components/gift-cards";
import jobApplicationForm from './components/job-application-form'
import login from './components/login.js'
import mapAutocomplete from './components/map-autocomplete.js'
import mapComponent from './components/map-component.js'
import overlay from './components/overlay.js'
import product from './components/product.js'
import productAvailability from './components/product-availability.js'
import productCarousel from './components/product-carousel.js'
import productShipTile from './components/product-ship-tile.js'
import productTile from './components/product-tile.js'
import returnsPortal from "./components/returns-portal";
import sidebar from './components/sidebar.js'
import storeAccordion from "./components/store-accordion";
import storeLocation from './components/store-location.js'
import storeLocator from './components/store-locator.js'
import storePickupLocation from './components/store-pickup-location.js'
import teamQuoteForm from './components/team-quote-form.js'

app
.component('accordion', accordion)
.component('account', account)
.component('brands', brands)
.component('cart', cart)
.component('cancellation-portal', cancellationPortal)
.component('collection', collection)
.component('collection-subcategories', collectionSubcategories)
.component('collection-topline', collectionTopline)
.component('footer-component', footerComponent)
.component('header-component', headerComponent)
.component('flow-page', flowPage)
.component('gift-cards', giftCards)
.component('job-application-form', jobApplicationForm)
.component('login', login)
.component('map-autocomplete', mapAutocomplete)
.component('map-component', mapComponent)
.component('overlay', overlay)
.component('product', product)
.component('product-availability', productAvailability)
.component('product-carousel', productCarousel)
.component('product-ship-tile', productShipTile)
.component('product-tile', productTile)
.component('returns-portal', returnsPortal)
.component('sidebar', sidebar)
.component('store-accordion', storeAccordion)
.component('store-location', storeLocation)
.component('store-locator', storeLocator)
.component('store-pickup-location', storePickupLocation)
.component('team-quote-form', teamQuoteForm)

app.mount("#app");